import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Zap, Settings, Code, CheckCircle } from 'lucide-react';

const TechnologySection = () => {
  const technologies = [
    {
      icon: <Zap className="h-12 w-12 text-green-600" />,
      name: "Shopify",
      subtitle: "Schneller Start für B2C",
      description: "Perfekt für den schnellen Einstieg in den E-Commerce mit bewährten B2C-Features.",
      bestFor: [
        "Kleine bis mittlere B2C-Shops",
        "Schneller Marktstart",
        "Standard-Verkaufsprozesse",
        "Begrenzte Anpassungen nötig"
      ],

      whenToChoose: "Wenn du schnell einen B2C-Shop brauchst und Standard-Prozesse ausreichen."
    },
    {
      icon: <Settings className="h-12 w-12 text-blue-600" />,
      name: "Shopware 6",
      subtitle: "Flexibel für B2B & B2C",
      description: "Die deutsche E-Commerce-Plattform mit starken B2B-Features und hoher Anpassbarkeit.",
      bestFor: [
        "Mittelständische Unternehmen",
        "B2B und B2C kombiniert",
        "Deutsche/EU-Compliance",
        "Komplexe Preisstrukturen"
      ],

      whenToChoose: "Wenn du B2B-Features, deutsche Compliance und Flexibilität brauchst."
    },
    {
      icon: <Code className="h-12 w-12 text-purple-600" />,
      name: "Custom Development",
      subtitle: "Maßgeschneidert für Komplexität",
      description: "Individuelle E-Commerce-Lösung für einzigartige Geschäftsprozesse und Anforderungen.",
      bestFor: [
        "Unternehmen mit hohen Kundenbindungszielen",
        "Einzigartige Geschäftsprozesse",
        "Komplexe System-Integration",
        "Spezielle Branchen-Anforderungen"
      ],

      whenToChoose: "Wenn Standard-Lösungen deine Anforderungen nicht erfüllen können.",
      link: "/business-apps"
    }
  ];

  return (
    <section className="py-16 md:py-24 bg-gradient-to-br from-gray-50 to-purple-50">
      <div className="container">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">
            <span className="text-blue-600">Shopify, Shopware oder Custom?</span> Wir helfen bei der Entscheidung
          </h2>
          <p className="text-lg text-gray-600">
            Jede E-Commerce-Technologie hat ihre Stärken. Wir analysieren deine Anforderungen 
            und empfehlen die beste Lösung für dein Unternehmen.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {technologies.map((tech, index) => (
            <Card key={index} className="border-0 shadow-lg bg-white h-full">
              <CardContent className="p-8 h-full flex flex-col">
                <div className="flex items-center mb-6">
                  {tech.icon}
                  <div className="ml-4">
                    <h3 className="text-2xl font-bold">{tech.name}</h3>
                    <p className="text-lg font-semibold text-gray-600">{tech.subtitle}</p>
                  </div>
                </div>
                
                <p className="text-gray-600 mb-6 leading-relaxed">
                  {tech.description}
                </p>
                
                <div className="mb-6">
                  <h4 className="font-semibold text-green-600 mb-3">✅ Ideal für:</h4>
                  <ul className="space-y-2">
                    {tech.bestFor.map((item, itemIndex) => (
                      <li key={itemIndex} className="flex items-center">
                        <CheckCircle className="h-4 w-4 text-green-500 mr-2 flex-shrink-0" />
                        <span className="text-gray-700 text-sm">{item}</span>
                      </li>
                    ))}
                  </ul>
                </div>
                

                
                <div className="mt-auto bg-blue-50 rounded-lg p-4">
                  <h4 className="font-semibold text-blue-800 mb-2">Wann wählen?</h4>
                  <p className="text-blue-700 text-sm mb-3">{tech.whenToChoose}</p>
                  {tech.link && (
                    <a 
                      href={tech.link}
                      className="inline-flex items-center text-blue-600 hover:text-blue-800 font-semibold text-sm transition-colors duration-200"
                    >
                      → Mehr zu Business Apps
                    </a>
                  )}
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TechnologySection; 